export default __webpack_public_path__ + "static/media/visa.2b7b4f31.svg";